import { Product } from "#/common/interfaces/conversionworld/Product";
// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";
import Item from "../comparison/item/Item";

@Component({
  mixins: [template],
  components: {
    Item,
  },
})
export default class ProductComparison extends Vue {
  @Prop()
  translation!: object;

  @Prop({ default: "de" })
  lang!: string;

  @Prop({ default: "GLOBAL" })
  country!: string;

  comparison;
  head;
  headTop = false;
  showSeparator = false;
  sepPosition = 0;
  mobileSize = false;
  showProducts = [0, 1];
  productsTable: Product[] = [];

  created() {
    window.addEventListener("resize", this.handleResize);
    let branchenId = "";
    let branche = this.$store.conversionWorld.branchen.find(
      (b) => b.slug == branchenId
    );
    if (branche) {
      let image = branche.images.bg_image_without_vehicle;
    }
  }

  mounted() {
    this.comparison = <HTMLElement>this.$refs["comparison"];
    this.head = <HTMLElement>this.$refs["head"];
    this.comparison.addEventListener("scroll", this.handleScroll);
    this.mobileSize = window.innerWidth > 620 ? false : true;
    this.prepare();
  }

  get products() {
    return this.$store.conversionWorld.compareProducts;
  }

  get columnsClass() {
    if (this.products.length === 3) {
      return "--three-col";
    } else return "--two-col";
  }

  @Watch("products")
  private prepare() {
    if (!this.mobileSize) {
      this.productsTable = this.products;
    } else {
      this.productsTable = [];
      this.showProducts.forEach((index) => {
        this.productsTable.push(this.products[index]);
      });
    }
  }

  public isProductActive(index) {
    return this.showProducts.findIndex((i) => i == index) >= 0;
  }

  public changePage($event) {
    $event.preventDefault();
    if (this.showProducts[0] == 0 && this.showProducts[1] == 1) {
      this.showProducts[0] = 1;
      this.showProducts[1] = 2;
    } else if (this.showProducts[0] == 1 && this.showProducts[1] == 2) {
      this.showProducts[0] = 0;
      this.showProducts[1] = 1;
    }
    this.prepare();
  }

  private handleScroll(e) {
    if (e.target.scrollTop > 150) {
      this.headTop = true;
      this.sepPosition = this.head.getBoundingClientRect().height;
      this.showSeparator = true;
    } else {
      this.headTop = false;
      this.showSeparator = false;
    }
  }

  private handleResize() {
    this.mobileSize = window.innerWidth > 768 ? false : true;
    Vue.nextTick(() => {
      this.sepPosition = this.head.getBoundingClientRect().height;
    });
    this.prepare();
  }

  public handleClose() {
    this.$emit("close");
  }

  public getPriceText(product: Product) {
    if (product.price) {
      if (product.price.no_information) {
        return this.translation["price_no_info"];
      }

      return this.translation["price_ab"] + " " + product.price.text;
    }

    return "";
  }

  getBodyBuilderLink(product: Product) {
    let link = "/" + this.lang + "/" + this.country + "/haendlersuche";

    if (!product.is_van_solution) {
      link += "?abhId=" + product.bodybuilder.id;
    }

    return link;
  }

  getBodyBuilderLinkText(product: Product) {
    if (product.is_van_solution) {
      return this.translation["link_goto_dealer"];
    } else {
      return this.translation["link_goto_bodybuilder"];
    }
  }
}
